import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Footer.css"; // optional for extra tweaks
import axios from "axios";
import { toast } from "react-toastify";
import { getHostName } from "../helpers/utils";

import { socialLinks } from "./socialLinks";

function FooterSection({ title, children, isOpen, onToggle }) {
  return (
    <div className="mb-3">
      {/* Title */}
      <h6
        className="fw-bold d-flex justify-content-between align-items-center"
        onClick={onToggle}
        style={{ cursor: "pointer" }}
      >
        {title}
        <i
          className={`bi ${
            isOpen ? "bi-chevron-up" : "bi-chevron-down"
          } d-md-none`}
        ></i>
      </h6>

      {/* Content */}
      <div className={`footer-collapse ${isOpen ? "open" : ""}`}>
        <div className="footer-collapse-inner">{children}</div>
      </div>
    </div>
  );
}

export default function Footer({ productsRef, bundlesRef }) {
  const [openSection, setOpenSection] = useState(null);

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const hostname = getHostName();
  const location = useLocation();


  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const handleSubscribe = async () => {
    if (!email) {
      setMessage("Please enter your email");
      return;
    }
    try {
      setLoading(true);
      setMessage("");

      // Call your backend API
      const res = await axios.post(`${hostname}/api/newsletter`, {
        email,
      });

      if (res.data.success) {
        toast.success("Email added to newsletter ");
        setEmail("");
      } else {
        setMessage(res.data.error || "Something went wrong");
      }
    } catch (err) {
      console.error(err);
      setMessage("Server error. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleScrollLink = (e, targetId, targetRef) => {
    e.preventDefault();

    if (location.pathname === "/") {
      // Already home → smooth scroll
      targetRef?.current?.scrollIntoView({ behavior: "smooth" });
    } else {
      // Hard reload with hash
      window.location.href = `/#${targetId}`;
    }
  };

  return (
    <footer className="bg-light pt-5">
      <div className="container">
        <div className="row">
          {/* Newsletter */}
          <div className="col-md-4 mb-4">
            <h4 className="fw-bold">Let’s get in touch</h4>
            <p className="text-muted my-3">
              Sign up for our newsletter and receive <br />
              discounts & gifts
            </p>

            <div className="newsletter-box my-3">
              <div className="input-group">
                <span className="input-group-text bg-white">
                  <i className="bi bi-envelope"></i>
                </span>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                />
                <button
                  className="btn btn-dark"
                  onClick={handleSubscribe}
                  disabled={loading}
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : (
                    <i className="bi bi-arrow-right"></i>
                  )}
                </button>
              </div>
              {message && <small className=" text-danger">{message}</small>}
            </div>
          </div>

          {/* Shop Links */}
          <div className="col-md-2 mb-4">
            <FooterSection
              title="Shop Aura"
              isOpen={openSection === "shop"}
              onToggle={() => toggleSection("shop")}
            >
              <ul className="list-unstyled text-muted">
                <li>
                  <a href="/affiliate-program">Affiliate Program</a>
                </li>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a
                    href="#!"
                    onClick={(e) =>
                      handleScrollLink(e, "products", productsRef)
                    }
                  >
                    All products
                  </a>
                </li>
                <li>
                  <a
                    href="#!"
                    onClick={(e) => handleScrollLink(e, "bundles", bundlesRef)}
                  >
                    Bundles
                  </a>
                </li>
              </ul>
            </FooterSection>
          </div>

          {/* Information */}
          <div className="col-md-3 mb-4">
            <FooterSection
              title="Information"
              isOpen={openSection === "info"}
              onToggle={() => toggleSection("info")}
            >
              <ul className="list-unstyled text-muted">
                <li>
                  <a href="/contact-us">Contact</a>
                </li>
                <li>
                  <a href="/refund-policy">Refund Policy</a>
                </li>
                <li>
                  <a href="/shipping-policy">Shipping Policy</a>
                </li>
                <li>
                  <a href="/returns-and-exchange-policy">
                    Returns & Exchange Policy
                  </a>
                </li>
              </ul>
            </FooterSection>
          </div>

          {/* Brand Info */}
          <div className="col-md-3 mb-4">
            <FooterSection
              title="Aura Skin Premium"
              isOpen={openSection === "brand"}
              onToggle={() => toggleSection("brand")}
            >
              <p className="text-muted small">
                Explore our collection of pure, herbal treasures to nurture your
                skin naturally.
              </p>
              <p className="mb-1">
                <a href="tel:+923312818985">+92 311 7266767</a>
              </p>
              <p>
                <a href="mailto:auraskinpremium@gmail.com">
                  auraskinpremium@gmail.com
                </a>
              </p>
              {/* <div className="d-flex gap-3 mt-2">
                <a href="#!">
                  <i className="bi bi-facebook fs-5"></i>
                </a>
                <a href="#!">
                  <i className="bi bi-instagram fs-5"></i>
                </a>
                <a href="#!">
                  <i className="bi bi-whatsapp fs-5"></i>
                </a>
                <a href="#!">
                  <i className="bi bi-tiktok fs-5"></i>
                </a>
              </div> */}
              <div className="d-flex gap-3 mt-2">
                {socialLinks.facebook && (
                  <a
                    href={socialLinks.facebook}
                    // href=""
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-facebook fs-5"></i>
                  </a>
                )}
                {socialLinks.instagram && (
                  <a
                    href={socialLinks.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-instagram fs-5"></i>
                  </a>
                )}
                {socialLinks.whatsapp && (
                  <a
                    href={socialLinks.whatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-whatsapp fs-5"></i>
                  </a>
                )}
                {socialLinks.tiktok && (
                  <a
                    href={socialLinks.tiktok}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-tiktok fs-5"></i>
                  </a>
                )}
              </div>
            </FooterSection>
          </div>
        </div>

        {/* Bottom */}
        <div className="text-center border-top pt-3 mt-3">
          <p className="mb-0 small text-muted">
            © {new Date().getFullYear()} Aura Skin Premium. all rights reserved
          </p>
          <p className="mb-0 small text-muted">
            Made with ❤ by Al Miraj Marketing
          </p>
        </div>
      </div>
    </footer>
  );
}

// import React from "react";
// import { Link } from "react-router-dom";
// import "./Footer.css"; // optional for styling tweaks

// export default function Footer() {
//   return (
//     <footer className="footer bg-light pt-5">
//       <div className="container">
//         <div className="row">
//           {/* Newsletter Section */}
//           <div className="col-md-4 mb-4">
//             <h4 className="fw-bold">Let's get in touch</h4>
//             <p>Sign up for our newsletter and receive discounts & gifts</p>
//             <div className="input-group">
//               <span className="input-group-text bg-white">
//                 <i className="bi bi-envelope"></i>
//               </span>
//               <input
//                 type="email"
//                 className="form-control"
//                 placeholder="Enter your email"
//               />
//               <button className="btn btn-dark">
//                 <i className="bi bi-arrow-right"></i>
//               </button>
//             </div>
//           </div>

//           {/* Shop Links */}
//           <div className="col-md-2 mb-4">
//             <h6 className="fw-bold">Shop Aura</h6>
//             <ul className="list-unstyled">
//               <li><Link to="/search">Search</Link></li>
//               <li><Link to="/">Home</Link></li>
//               <li><Link to="/products">All products</Link></li>
//               <li><Link to="/bundles">Herbal Bundles</Link></li>
//             </ul>
//           </div>

//           {/* Information Links */}
//           <div className="col-md-3 mb-4">
//             <h6 className="fw-bold">Information</h6>
//             <ul className="list-unstyled">
//               <li><Link to="/contact">Contact</Link></li>
//               <li><Link to="/refund-policy">Refund Policy</Link></li>
//               <li><Link to="/shipping-policy">Shipping Policy</Link></li>
//               <li><Link to="/returns">Returns & Exchange Policy</Link></li>
//             </ul>
//           </div>

//           {/* Brand Info */}
//           <div className="col-md-3 mb-4">
//             <h6 className="fw-bold">Aura Skin Premium</h6>
//             <p>
//               Explore our collection of pure, herbal treasures to nurture your
//               skin and hair naturally.
//             </p>
//             <p className="mb-1"><a href="tel:+923312818985">+92 331 2818985</a></p>
//             <p><a href="mailto:auraskinpremium@gmail.com">auraskinpremium@gmail.com</a></p>

//             {/* Social Icons */}
//             <div className="d-flex gap-3 mt-2">
//               <a href="#!"><i className="bi bi-facebook fs-5"></i></a>
//               <a href="#!"><i className="bi bi-instagram fs-5"></i></a>
//               <a href="#!"><i className="bi bi-instagram fs-5"></i></a>
//           <a href="#!"><i className="bi bi-whatsapp"></i></a>

//             </div>
//           </div>
//         </div>

//         {/* Footer Bottom */}
//         <div className="text-center border-top pt-3 mt-3">
//           <p className="mb-0">
//             © {new Date().getFullYear()} Aura Skin Premium. all rights reserved.
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// }

// import React, { useState, useRef, useEffect } from "react";
// import { Link } from "react-router-dom";
// import "./Footer.css"; // 👈 Import the CSS for animations

// // Collapsible Section
// function FooterSection({ title, children, isOpen, onToggle }) {
//   const contentRef = useRef(null);
//   const [height, setHeight] = useState("0px");

//   useEffect(() => {
//     if (isOpen && contentRef.current) {
//       setHeight(contentRef.current.scrollHeight + "px");
//     } else {
//       setHeight("0px");
//     }
//   }, [isOpen]);

//   return (
//     <div className="bb-footer-widget">
//       {/* Heading */}
//       <h4
//         className="bb-footer-heading d-flex justify-content-between align-items-center"
//         onClick={onToggle}
//         style={{ cursor: "pointer" }}
//       >
//         {title}
//         <i
//           className={`bi ${isOpen ? "bi-chevron-up" : "bi-chevron-down"} d-lg-none`}
//         ></i>
//       </h4>

//       {/* Collapsible Content */}
//       <div
//         className={`footer-collapse ${isOpen ? "open" : ""}`}
//         style={{ maxHeight: height }}
//         ref={contentRef}
//       >
//         <div className="footer-collapse-inner">{children}</div>
//       </div>
//     </div>
//   );
// }

// export default function Footer({ applyForAffiliateProgram }) {
//   const [openSection, setOpenSection] = useState(null);

//   const handleToggle = (section) => {
//     setOpenSection(openSection === section ? null : section);
//   };

//   return (
//     <footer className="bb-footer margin-t-50">
//       <div className="footer-container">
//         <div className="footer-top padding-tb-50">
//           <div className="container">
//             <div className="row m-minus-991">
//               {/* Company Info */}
//               <div className="col-sm-12 col-lg-3 bb-footer-cat">
//                 <div className="bb-footer-widget bb-footer-company">
//                   <img
//                     src="/img/logo/logo.png"
//                     className="bb-footer-logo"
//                     alt="footer logo"
//                   />
//                   <img
//                     src="/img/logo/logo-dark.png"
//                     className="bb-footer-dark-logo"
//                     alt="footer logo"
//                   />
//                   <p className="bb-footer-detail">
//                     BlueBerry is the biggest market of grocery products. Get
//                     your daily needs from our store.
//                   </p>
//                   <div className="bb-app-store">
//                     <div className="input-group mb-3">
//                       <span className="input-group-text" id="basic-addon1">
//                         <i className="bi bi-envelope"></i>
//                       </span>
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="Get in touch"
//                         aria-label="Get in touch"
//                         aria-describedby="basic-addon1"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Category */}
//               <div className="col-sm-12 col-lg-2 bb-footer-info">
//                 <FooterSection
//                   title="Category"
//                   isOpen={openSection === "category"}
//                   onToggle={() => handleToggle("category")}
//                 >
//                   <ul className="align-items-center">
//                     <li className="bb-footer-link">
//                       <Link to="/shop-left-sidebar-col-3">Dairy &amp; Milk</Link>
//                     </li>
//                     <li className="bb-footer-link">
//                       <Link to="/shop-banner-left-sidebar-col-3">Snack &amp; Spice</Link>
//                     </li>
//                     <li className="bb-footer-link">
//                       <Link to="/shop-full-width-col-5">Fast Food</Link>
//                     </li>
//                     <li className="bb-footer-link">
//                       <Link to="/shop-list-left-sidebar">Juice &amp; Drinks</Link>
//                     </li>
//                     <li className="bb-footer-link">
//                       <Link to="/shop-list-full-col-2">Bakery</Link>
//                     </li>
//                     <li className="bb-footer-link">
//                       <Link to="/shop-banner-right-sidebar-col-4">Seafood</Link>
//                     </li>
//                   </ul>
//                 </FooterSection>
//               </div>

//               {/* Company */}
//               <div className="col-sm-12 col-lg-2 bb-footer-account">
//                 <FooterSection
//                   title="Company"
//                   isOpen={openSection === "company"}
//                   onToggle={() => handleToggle("company")}
//                 >
//                   <ul className="align-items-center">
//                     <li className="bb-footer-link">
//                       <Link to="/about-us">About us</Link>
//                     </li>
//                     <li className="bb-footer-link">
//                       <Link to="/track-order">Delivery</Link>
//                     </li>
//                     <li className="bb-footer-link">
//                       <Link to="/faq">Legal Notice</Link>
//                     </li>
//                     <li className="bb-footer-link">
//                       <Link to="/terms">Terms &amp; Conditions</Link>
//                     </li>
//                     <li className="bb-footer-link">
//                       <Link to="/checkout">Secure Payment</Link>
//                     </li>
//                     <li className="bb-footer-link">
//                       <Link to="/contact-us">Contact us</Link>
//                     </li>
//                   </ul>
//                 </FooterSection>
//               </div>

//               {/* Account */}
//               <div className="col-sm-12 col-lg-2 bb-footer-service">
//                 <FooterSection
//                   title="Account"
//                   isOpen={openSection === "account"}
//                   onToggle={() => handleToggle("account")}
//                 >
//                   <ul className="align-items-center">
//                     <li className="bb-footer-link">
//                       <Link to="/login">Sign In</Link>
//                     </li>
//                     <li className="bb-footer-link">
//                       <Link to="/cart">View Cart</Link>
//                     </li>
//                     <li className="bb-footer-link">
//                       <Link to="/faq">Return Policy</Link>
//                     </li>
//                     <li className="bb-footer-link">
//                       <Link to="/shop-left-sidebar-col-3">Become a Vendor</Link>
//                     </li>
//                     <li className="bb-footer-link">
//                       <a href="#!" onClick={applyForAffiliateProgram}>
//                         Affiliate Program
//                       </a>
//                     </li>
//                     <li className="bb-footer-link">
//                       <Link to="/checkout">Payments</Link>
//                     </li>
//                   </ul>
//                 </FooterSection>
//               </div>

//               {/* Contact */}
//               <div className="col-sm-12 col-lg-3 bb-footer-cont-social">
//                 <FooterSection
//                   title="Contact"
//                   isOpen={openSection === "contact"}
//                   onToggle={() => handleToggle("contact")}
//                 >
//                   <ul className="align-items-center">
//                     <li className="bb-footer-link bb-foo-location d-flex">
//                       <span>
//                         <i className="bi bi-geo-alt" style={{ fontSize: "25px" }}></i>
//                       </span>
//                       <p className="ms-2">
//                         971 Lajamni, Motavarachha, Surat, Gujarat, Bharat 394101.
//                       </p>
//                     </li>
//                     <li className="bb-footer-link bb-foo-call">
//                       <span>
//                         <i className="bi bi-whatsapp"></i>
//                       </span>
//                       <a href="tel:+009876543210" className="ms-2">
//                         +00 9876543210
//                       </a>
//                     </li>
//                     <li className="bb-footer-link bb-foo-mail">
//                       <span>
//                         <i className="bi bi-envelope" />
//                       </span>
//                       <a href="mailto:example@email.com" className="ms-2">
//                         example@email.com
//                       </a>
//                     </li>
//                   </ul>
//                 </FooterSection>

//                 {/* Social Icons */}
//                 <div className="bb-footer-social mt-3">
//                   <ul className="d-flex gap-3">
//                     <li className="bb-footer-link">
//                       <a href="#!"><i className="bi bi-facebook"></i></a>
//                     </li>
//                     <li className="bb-footer-link">
//                       <a href="#!"><i className="bi bi-twitter-x"></i></a>
//                     </li>
//                     <li className="bb-footer-link">
//                       <a href="#!"><i className="bi bi-instagram"></i></a>
//                     </li>
//                     <li className="bb-footer-link">
//                       <a href="#!"><i className="bi bi-whatsapp"></i></a>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//               {/* End Contact */}
//             </div>
//           </div>
//         </div>

//         {/* Footer Bottom */}
//         <div className="footer-bottom">
//           <div className="container">
//             <div className="row">
//               <div className="bb-bottom-info">
//                 <div className="footer-copy">
//                   <div className="footer-bottom-copy">
//                     <div className="bb-copy">
//                       Copyright © {new Date().getFullYear()}{" "}
//                       <Link className="site-name" to="/">
//                         Aura Skin Premium
//                       </Link>{" "}
//                       all rights reserved.
//                     </div>
//                   </div>
//                 </div>
//                 <div className="footer-bottom-right">
//                   <div className="footer-bottom-payment d-flex justify-content-center">
//                     <div className="payment-link">
//                       <img src="/img/payment/payment.png" alt="payment" />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }
